import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { authConfig } from "../../../api-config/authConfig"

const initialState = {
    editLoading : false,
    editResponse : [],
    error : ""
}
// change_status_user_staff_admin/{id}
// user_staff_update_by_admin/{id}
const editSuperAdminStaff = createAsyncThunk("api/updateSuperAdminStaff", async(formData) => {
    return await authConfig.post("/user_staff_update_by_admin", formData).then((response) => {
        return response.data
    }).catch((e) => {
        console.log(e, "Error")
    })
})

const EditSuperAdminStaffSlice = createSlice({
    name : "EditSuperAdminStaffSlice",
    initialState,
    extraReducers: (builder) => {
        builder.
        addCase(editSuperAdminStaff.pending, (state) => {
            state.editLoading = true
        })
        .addCase(editSuperAdminStaff.fulfilled, (state, {payload}) => {
            state.editResponse = payload
            state.editLoading = false
        })
        .addCase(editSuperAdminStaff.rejected, (state) => {
            state.editLoading = false
            state.error = "Something went wrong!"
        })
    }
})

export {editSuperAdminStaff}

export default EditSuperAdminStaffSlice.reducer